import React, { useContext } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { StoreContext } from "../../../../../../store/StoreProvider";

const Quota = ({ text }) => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { quotaNumber } = sna;

  return (
    <Box sx={{ display: "flex", color: "#6D6D6D" }}>
      <Typography variant="body2" sx={{ lineHeight: "20.27px" }}>
        {text}
        <FormattedMessage
          id="snaPage.left.quota"
          defaultMessage="可免費使用額度剩"
        />
        &nbsp;
      </Typography>
      <Typography
        variant="body2"
        sx={{
          lineHeight: "20.27px",
          color: "#0EA2E9",
          fontWeight: "700",
        }}
      >
        {quotaNumber}%
      </Typography>
      <Typography variant="body2" sx={{ lineHeight: "20.27px" }}>
        &nbsp;
        <FormattedMessage
          id="snaPage.update.quota"
          defaultMessage="(每日00:00更新)"
        />
      </Typography>
    </Box>
  );
};

export default Quota;

Quota.defaultProps = {
  // quota: 0,
  text: null,
};

Quota.propTypes = {
  // quota: PropTypes.number,
  text: PropTypes.string,
};
